<template>
  <div class="vd-gl-content">
    <!-- 检索条件 -->
    <a-row class="vd-toolbar">
      <a-col class="vd-bar">
        <a-form layout="inline">
          <a-form-item>
            <a-tooltip title="群号">
              <a-input
                class="vd-input-xs"
                placeholder="群号"
                v-model="form.groupQq"
              />
            </a-tooltip>
          </a-form-item>
          <a-form-item>
            <a-tooltip title="负责人工号">
              <a-input
                class="vd-input-xs"
                placeholder="负责人工号"
                v-model="form.code"
              />
            </a-tooltip>
          </a-form-item>

          <a-form-item>
            <a-tooltip title="群所属地区">
              <a-cascader
                style="width: 216px"
                :options="areaTree"
                v-model="form.areaPath"
                :field-names="{
                  label: 'name',
                  value: 'id',
                  children: 'children',
                }"
                placeholder="群所属地区"
                :change-on-select="true"
              />
            </a-tooltip>
          </a-form-item>
          <a-form-item>
            <a-tooltip title="群所属项目">
              <a-select
                style="width: 116px"
                allowClear
                v-model="form.category"
                placeholder="群所属项目"
              >
                <template v-for="item in subList">
                  <a-select-option :key="item.id">
                    {{ item.nickname }}
                  </a-select-option>
                </template>
              </a-select>
            </a-tooltip>
          </a-form-item>
          <a-form-item>
            <a-tooltip title="群机器人所属地区">
              <a-select
                style="width: 116px"
                allowClear
                v-model="form.loginQq"
                placeholder="归属机器人"
              >
                <template v-for="(item, index) in areaList">
                  <a-select-option :value="item.login_qq" :key="index">
                    {{ item.zh }}
                  </a-select-option>
                </template>
              </a-select>
            </a-tooltip>
          </a-form-item>

          <a-form-item :wrapper-col="wrapperCol">
            <a-button type="primary" icon="search" @click="searchInfo" />
          </a-form-item>
          <a-form-item :wrapper-col="wrapperCol">
            <a-button type="danger" icon="redo" @click="searchRedo" />
          </a-form-item>
        </a-form>
      </a-col>
      <a-col class="vd-bar">
        <a-form layout="inline">
          <a-form-item label="归属机器人">
            <a-select
              style="width: 108px"
              v-model="form.newLoginQq"
              placeholder="请选择"
            >
              <template v-for="(item, index) in areaList">
                <a-select-option :value="item.login_qq" :key="index">
                  {{ item.zh }}
                </a-select-option>
              </template>
            </a-select>
          </a-form-item>
          <a-form-item :wrapper-col="wrapperCol">
            <a-button type="primary" @click="newList">重新拉取群列表</a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <!-- 内容主体 -->
    <a-table
      :data-source="list"
      row-key="id"
      size="small"
      :loading="loading"
      :pagination="pagination"
    >
      <a-table-column title="ID" align="center" data-index="id" />
      <a-table-column title="群号" align="center" data-index="group_qq" />
      <a-table-column title="群名称" align="center" data-index="group_name" />
      <a-table-column title="地区" align="center" data-index="area_name" />
      <a-table-column title="项目" align="center" data-index="category_name" />
      <a-table-column title="上限/人数" align="center">
        <template slot-scope="record">
          {{ record.num_max }} / {{ record.num }}
        </template>
      </a-table-column>
      <a-table-column title="归属机器人" align="center" data-index="area_local">
        <template slot-scope="text, record">
          <a-tooltip title="机器未在群中" v-if="record.robot_out_time > 0">
            <a-tag color="red"> {{ text }}</a-tag>
          </a-tooltip>
          <a-tooltip title="正常" v-else>
            <a-tag color="blue"> {{ text }}</a-tag>
          </a-tooltip>
        </template>
      </a-table-column>
      <a-table-column title="操作" align="center">
        <template slot-scope="record">
          <a-tooltip title="更新群内成员数据">
            <a-icon
              class="common-icon"
              type="redo"
              @click="updateInfo(record)"
            />
          </a-tooltip>
          <a-tooltip title="修改所属信息">
            <a-icon class="common-icon" type="edit" @click="modify(record)" />
          </a-tooltip>
          <a-tooltip title="详情">
            <a-icon
              class="common-icon"
              type="small-dash"
              @click="detail(record)"
            />
          </a-tooltip>
        </template>
      </a-table-column>
      <a-table-column title="添加时间" align="center" data-index="add_time">
        <span slot-scope="time">
          {{ $FormatUtil.timestamp2date(time) }}
        </span>
      </a-table-column>
    </a-table>

    <a-modal
      :visible="visible"
      title="修改信息"
      ok-text="确认"
      cancel-text="取消"
      @ok="qqConfirm"
      @cancel="qqCancel"
    >
      <a-form-model
        ref="qqForm"
        :model="qqForm"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="地区" prop="name">
          <a-cascader
            style="width: 216px"
            :options="areaTree"
            v-model="qqForm.areaPath"
            :field-names="{
              label: 'name',
              value: 'id',
              children: 'children',
            }"
            placeholder="请选择用户所属地区"
            :change-on-select="true"
          />
        </a-form-model-item>

        <a-form-model-item label="项目" prop="name">
          <a-select
            style="width: 216px"
            v-model="qqForm.category"
            placeholder="所属项目"
          >
            <template v-for="item in subList">
              <a-select-option :key="item.id">
                {{ item.nickname }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { get_sub } from '@/api'
import { qq_list, get_new_group_list, pull_group, qq_modify } from '@/api/qq'
import { get_area_tree } from '@/api/auth'
import store from '@/store'

export default {
  name: 'Setting',
  data() {
    return {
      loading: false,
      visible: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      areaList: [],
      areaTree: [],
      subList: [],
      list: [],
      form: {
        groupQq: '',
        code: '',
        loginQq: undefined,
        areaPath: [],
        category: undefined,
        newLoginQq: undefined,
      },
      qqForm: {
        id: undefined,
        areaPath: [],
        category: undefined,
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: 15,
        hideOnSinglePage: true,
        showTotal: (total) => `总共 ${total} 条`,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
    }
  },
  created() {
    this.areaList = store.getters.qqRoot
    this.getData()
    // 获取下拉中的数据
    get_area_tree().then((res) => {
      if (res.code === 1) {
        this.areaTree = res.areaTree
      }
    })
    get_sub('item_type').then((res) => {
      if (res.code === 1) {
        this.subList = res.list
      }
    })
  },
  methods: {
    // 更新群数据
    updateInfo(e) {
      pull_group({
        login_qq: e.login_qq,
        group_qq: e.group_qq,
      }).then((res) => {
        if (res['code'] === 1) {
          this.$message.success('更新成功')
          this.getData()
        } else {
          this.$message.warning(res['msg'])
        }
      })
    },
    // 获取活动详情
    detail(e) {
      this.$router.push({
        path: '/qq/detail',
        query: { id: e.id },
      })
    },

    // 获取数据
    getData() {
      this.loading = true
      qq_list({
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
        group_qq: this.form.groupQq,
        code: this.form.code,
        login_qq: this.form.loginQq,
        category: this.form.category,
        area_path: this.form.areaPath,
      }).then((res) => {
        this.loading = false
        if (res.code === 1) {
          this.list = res.list
          this.pagination.total = res.total
        } else {
          this.pagination.total = 0
          this.list = []
          this.$message.warning(res.msg)
        }
      })
    },
    // 重新拉取群列表
    newList() {
      if (this.form.newLoginQq !== undefined) {
        get_new_group_list({
          login_qq: this.form.newLoginQq,
        }).then((res) => {
          if (res.code === 1) {
            this.getData()
          } else {
            this.$message.warning({
              content: res.msg,
              key: 'new_login_qq',
            })
          }
        })
      } else {
        this.$message.warning({
          content: '请选择重新拉取的地区',
          key: 'new_login_qq',
        })
      }
    },
    // 搜索条件重置
    searchRedo() {
      this.pagination.current = 1
      this.form.groupQq = ''
      this.form.code = ''
      this.form.loginQq = undefined
      this.form.category = undefined
      this.form.areaPath = []

      this.getData()
    },
    // 搜索数据
    searchInfo() {
      this.pagination.current = 1
      this.getData()
    },
    // 修改数据
    modify(record) {
      this.visible = !this.visible
      this.qqForm.id = record.id

      if (!this.$HelperUtil.isEmpty(record.area_path)) {
        let path = record.area_path.split(',')
        path = path.map((data) => {
          return +data
        })
        this.qqForm.areaPath = path
      } else {
        this.qqForm.areaPath = record.area_path
      }
      this.qqForm.category =
        record.category_id === 0 ? undefined : record.category_id
    },
    // 提交数据
    qqConfirm() {
      qq_modify({
        id: this.qqForm.id,
        areaPath: this.qqForm.areaPath,
        category: this.qqForm.category,
      }).then((res) => {
        this.visible = !this.visible
        if (res.code === 1) {
          this.getData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    // 取消提交数据
    qqCancel() {
      this.visible = !this.visible
      // 数据清除
      this.qqForm.id = this.qqForm.area = this.qqForm.category = undefined
      this.qqForm.areaPath = []
    },
  },
}
</script>

<style scoped></style>
